import Vue from 'vue';
import { localeWeekdayIndicesMonToFri } from '@/utils';
import firebase from 'firebase/app';
import moment from 'moment';

moment.locale('en-GB');


function getLocalStorage(key) {
  let user = firebase.auth().currentUser;
  return JSON.parse(localStorage.getItem(user.uid + '.prefs.' + key));
}

function setLocalStorage(key, value) {
  let user = firebase.auth().currentUser;
  localStorage.setItem(user.uid + '.prefs.' + key, JSON.stringify(value));
}

function getPref(name, defaultValue) {
  let value = getLocalStorage(name);
  return value !== null ? value : defaultValue;
}

const state = () => ({

  preferences: {
    'planner.numberPrevWeeks': 0,
    'planner.numberNextWeeks': 1,
    'planner.weekdays': localeWeekdayIndicesMonToFri(),
    'layout.hideDragHandle': false,
  }

})

const getters = {
  getUserPreferences: (state) => {
    return state.preferences;
  }
}

const actions = {

}

const mutations = {

  loadUserPreferences(state) {
    let preferences = {
      'planner.numberPrevWeeks': getPref('planner.numberPrevWeeks', 0),
      'planner.numberNextWeeks': getPref('planner.numberNextWeeks', 1),
      'planner.weekdays': getPref('planner.weekdays', localeWeekdayIndicesMonToFri()),
      'layout.hideDragHandle': getPref('planner.hideDragHandle', false),
    };
    Vue.set(state, "preferences", preferences);
  },

  setPreference(state, {key, value}) {
    Vue.set(state.preferences, key, value);
    setLocalStorage(key, value);
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
